import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { createMetaManager } from "vue-meta";
import "vue3-toastify/dist/index.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import ErrorLoggerPlugin from "@/utils/error-logger.plugin";
import settings, { Settings } from "@/config/settings";

const url = new URL(location.pathname, location.href).href;
await fetch(url.toString() + 'config.json').then((response) => {
  response.json().then((configData: Settings) => {
    if (process.env.VUE_APP_API_URL) {
      settings.apiBaseUrl = process.env.VUE_APP_API_URL;
    }

    if (process.env.VUE_APP_GOOGLE_RECAPTCHA_KEY) { 
      settings.googleRecaptchaKey = process.env.VUE_APP_GOOGLE_RECAPTCHA_KEY;
    }

    if(configData.apiBaseUrl) {
      settings.apiBaseUrl = configData.apiBaseUrl;
    }

    if(configData.googleRecaptchaKey) {
      console.log("INSIDE RECAPTCHA: " + configData.googleRecaptchaKey);
      settings.googleRecaptchaKey = configData.googleRecaptchaKey;
    }

    store.commit('setSettings', settings);

    const app = createApp(App);
    app
      .use(store)
      .use(router)
      .use(createMetaManager())
      .use(ErrorLoggerPlugin, {
        endpoint: "/api/client-errors",
        appName: "cobra-ui",
        environment: process.env.NODE_ENV ?? "unknown",
        router,
      })
      .mount("#app");
  });
});